import {ProductItem} from "../../models/Product"

interface MapItems {
    items: ProductItem[]
    productSummaryTemplateName?: string
    imageRatio?: string
}

export const mapItems = ({items, productSummaryTemplateName, imageRatio}: MapItems) => {
    if (productSummaryTemplateName || imageRatio) {
        return items.map(item => {
            const newItem = {...item}
            if (productSummaryTemplateName) {
                newItem.productSummaryTemplateName = productSummaryTemplateName
            }
            if (imageRatio) {
                newItem.imageRatio = imageRatio
            }
            return newItem
        })
    }
    return items
}
